

'use strict';


var SiteTransitionManager = function(onEndCallback) {
    this.animStartTime = null;
    this.onEndCallback = onEndCallback;

    this.animationsComplete = {
        a: false,
        a1: false,
        b: false,
        c: false,
        d: false,
        e: false,
        f: false,
        g: false
    };

    this.configureElems();
};

SiteTransitionManager.prototype = {
    constructor: SiteTransitionManager,

    configureElems: function() {
        this.$headerLogo = $('[data-header-logo]');
        this.$grid = $('[data-games-grid]');
        this.$gridItems = $('[data-grid-item]');
        this.$gridTitles = $('[data-grid-title]');
        this.$footer = $('[data-footer]');
        this.$nameRouletteContainer = $('[data-name-roulette-container]');
        this.$aboutSection = $('[data-about-section]');
    },

    onAnimationUpdate: function() {
        
        var timeElapsed = Date.now() - this.animStartTime;

        // console.log('timeElapsed', timeElapsed);

        // logo
        if ( timeElapsed > 100 && !this.animationsComplete.a ) {
            this.animationsComplete.a = true;
            this.$headerLogo.addClass('show');
        }
        
        // name roulette
        if ( timeElapsed > 500 && !this.animationsComplete.a1 ) {
            this.animationsComplete.a1 = true;
            this.$nameRouletteContainer.addClass('show');
        }

        // grid
        if ( timeElapsed > 650 && !this.animationsComplete.b ) {
            this.animationsComplete.b = true;
            this.$grid.addClass('show');
        }

        // grid item img containers
        if ( timeElapsed > 850 && !this.animationsComplete.c ) {
            this.animationsComplete.c = true;
            this.$gridItems.addClass('show-grid-img');
        }

        // grid images
        var gridImagesTime = 950 + (this.$gridItems.length * 110);
        if ( timeElapsed > gridImagesTime && !this.animationsComplete.d ) {
            this.animationsComplete.d = true;
            this.animateImages();
        }
        
        // titles
        if ( timeElapsed > gridImagesTime + 700 && !this.animationsComplete.e ) {
            this.animationsComplete.e = true;
            this.$gridTitles.addClass('show');
        }

        // vendors
        if ( timeElapsed > gridImagesTime + 800 && !this.animationsComplete.f ) {
            this.animationsComplete.f = true;
            this.animateVendors();
        }

        // footer + other sections
        if ( timeElapsed > gridImagesTime + 1200 && !this.animationsComplete.g ) {
            this.animationsComplete.g = true;

            if (this.$footer.length > 0) {
                this.$footer.addClass('show');
            }

            if (this.$aboutSection.length > 0) {
                this.$aboutSection.addClass('show');
            }

            if (this.onEndCallback) {
                this.onEndCallback();
            }
        }

        window.requestAnimationFrame( this.onAnimationUpdate.bind(this) );
    },


    loadGridImage: function($container, delay) {
        window.setTimeout(function() {
            $container.addClass('show-img');
        }, delay);
    },

    animateImages: function() {
        var loadGridImage = this.loadGridImage.bind(this);

        var delayAmount = 100;

        $('[data-grid-img-container]').each(function(index) {
            var imgElem = $(this).find('img')[0];
            var delay = delayAmount * index;
            
            if (imgElem.complete && imgElem.naturalWidth > 0) {
                loadGridImage( $(this), delay );
                return;
            }

            imgElem.onload = function() {
                loadGridImage( $(this), delay );
            };
        });
    },

    
    animateVendors: function() {
        $('[data-vendors]').each(function() {
            $(this).children().addClass('show');
        });
    },


    play: function() {
        this.animStartTime = Date.now();

        // start animation update
        this.onAnimationUpdate();
    }
};


module.exports = SiteTransitionManager;





/*****************
 ** WEBPACK FOOTER
 ** ./dev/js/src/siteTransitionManager.js
 ** module id = 8
 ** module chunks = 0
 **/